import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "numberOfRealEstates", "table", "infoBox"];

  removedRows = [];

  connect() {
    this.renderRows();
  }

  renderRows() {
    const numberOfRows = parseInt(this.numberOfRealEstatesTarget.value);

    if (numberOfRows === 0) {
      this.numberOfRealEstatesTarget.value = 1; // Reset to 1 if zero is entered
      this.showInfoBox();
    } else {
      const currentRows = this.rowsTarget.querySelectorAll('tr').length;
      if (numberOfRows > currentRows) {
        for (let i = currentRows; i < numberOfRows; i++) {
          this.addRow();
        }
      } else if (numberOfRows < currentRows) {
        for (let i = currentRows; i > numberOfRows; i--) {
          this.removeRow();
        }
      }
      this.hideInfoBox();
    }
  }

  addRow() {
    if (this.removedRows.length > 0) {
      const row = this.removedRows.pop();
      this.rowsTarget.appendChild(row);
    } else {
      this.addRowFromTemplate();
    }
  }

  addRowFromTemplate() {
    const newRow = document.createElement("tr");
    newRow.innerHTML = `
      <td>
        <div class="select">
          <select name="real_estate_assets[][typeRealEstatePick__c]" id="real_estate_assets__typeRealEstatePick__c" class="select">
            <option value="">Bitte auswählen</option>
            <option value="Apartment">Wohnung</option>
            <option value="House">Haus</option>
            <option value="Other">Sonstige</option>
          </select>
        </div>
      </td>
      <td>
        <div class="select">
          <select name="real_estate_assets[][usagePick__c]" id="real_estate_assets__usagePick__c" class="select">
            <option value="">Bitte auswählen</option>
            <option value="Self Usage">Selbstnutzung</option>
            <option value="Rented">Vermietung</option>
            <option value="Both">Gemischt</option></select>
        </div>
      </td>
      <td><input class="input" type="text" name="real_estate_assets[][description__c]" value=""></td>
      <td><input class="input" type="number" name="real_estate_assets[][livingSpace__c]" min="0" value=""></td>
      <td><div class="field"><p class="control has-icons-left"><input type="number" name="real_estate_assets[][value__c]" id="real_estate_assets__value__c" value="" class="input" min="0"><span class="icon is-small is-left"><box-icon name="euro"></box-icon></span></p></div></td>
      <td><div class="field"><p class="control has-icons-left"><input type="number" name="real_estate_assets[][monthlyPayout__c]" id="real_estate_assets__monthlyPayout__c" value="" class="input" min="0"><span class="icon is-small is-left"><box-icon name="euro"></box-icon></span></p></div></td>
    `;
    this.rowsTarget.appendChild(newRow);
  }

  removeRow() {
    const lastRow = this.rowsTarget.querySelector('tr:last-child');
    if (lastRow) {
      this.removedRows.push(lastRow);
      this.rowsTarget.removeChild(lastRow);
    }
  }

  showInfoBox() {
    this.infoBoxTarget.style.display = 'block';
  }

  hideInfoBox() {
    this.infoBoxTarget.style.display = 'none';
  }

  numberOfRealEstatesChanged() {
    this.renderRows();
  }
}
